// All copy and data for the Traveler Submerged media kit landing page.
// UK English. No em dashes. Generic media kit, partner-agnostic.

export const LOGOS = {
  full: "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/9wefcw8n_transparent%20watermark-01.png",
  wordmark: "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/ad6g5vjo_transparent%20watermark-01%20%28%20text%20logo%20%29-01.png",
  emblem: "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/sluj9mpf_trasnparent%20icon-01.png",
};

export const IMAGES = {
  // Robin Bull in Procean drysuit, close-up (hero)
  hero: "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/1zfuhwql_GPTempDownload%20256.JPG",
  // Robin Bull underwater profile (founder portrait)
  founder: "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/tjy0brgp_GPTempDownload%20269.JPG",
  // Wide archway diver
  ocean1: "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/cytgva84_GPTempDownload%20254.JPG",
  // Dark cavern silhouette
  ocean2: "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/t79bwy42_GPTempDownload%20260.jpg",
  proof: [
    "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/vbm4x7zi_IMG_8597.jpg",
    "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/a0lh5c69_IMG_8598.jpg",
    "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/racbh0wb_IMG_8599.jpg",
    "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/8e7wc01z_IMG_8600.jpg",
    "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/s4mdfgu4_IMG_8601.jpg",
    "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/mhwyzmbi_IMG_8602.jpg",
    "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/7z9xgwr5_IMG_8603.jpg",
    "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/gyhhpbxn_IMG_8604.jpg",
    "https://customer-assets.emergentagent.com/job_traveler-submerged/artifacts/m42hu0vj_IMG_8605.jpg",
  ],
};

export const NAV_LINKS = [
  { id: "founder", label: "Founder" },
  { id: "about", label: "Brand" },
  { id: "reach", label: "Reach" },
  { id: "platforms", label: "Platforms" },
  { id: "audience", label: "Audience" },
  { id: "partnerships", label: "Partnerships" },
  { id: "rates", label: "Rates" },
  { id: "contact", label: "Contact" },
];

export const HERO_PROOF = [
  { value: "31.2k+", label: "Combined audience" },
  { value: "9.3M", label: "Video views" },
  { value: "5.86M", label: "Total reach" },
  { value: "105k+", label: "Engagements" },
  { value: "3,000+", label: "Dives logged" },
  { value: "PADI", label: "Staff Instructor" },
];

export const CREDENTIALS = [
  "PADI Staff Instructor",
  "PADI Freediving Instructor",
  "Tec diver",
  "EFR Instructor",
  "3,000+ dives",
  "Digital marketing strategist",
  "Luxury hospitality background",
  "Underwater content creator",
];

export const CONTENT_PILLARS = [
  "Dive education and training",
  "Technical diving mindset",
  "Freediving and breath awareness",
  "Mindful diving",
  "Gear testing and product education",
  "Underwater video and content creation",
  "Dive travel and Mediterranean diving",
  "Ocean conservation and cleanups",
  "Digital marketing and AI tools for dive professionals",
];

export const REACH_STATS = [
  { value: "31.2k+", label: "Combined social audience", sub: "Across Instagram, Facebook and TikTok" },
  { value: "21,526", label: "Instagram followers", sub: "Core authority channel" },
  { value: "8,200", label: "Facebook followers", sub: "Mature dive audience" },
  { value: "1,541", label: "TikTok followers", sub: "Emerging growth channel" },
  { value: "393", label: "Newsletter subscribers", sub: "Opt-in dive industry list" },
  { value: "336k", label: "Facebook views", sub: "Last 28 days" },
  { value: "5.8k", label: "Facebook engagements", sub: "Last 28 days" },
  { value: "1,439", label: "TikTok followers gained", sub: "Last 365 days" },
];

export const PERFORMANCE_STATS = [
  { value: "9.3M", label: "Total video views" },
  { value: "5.86M", label: "Total reach" },
  { value: "105.2k", label: "Engagements" },
  { value: "91.3k", label: "Reactions" },
  { value: "4.5k", label: "Comments" },
  { value: "9.4k", label: "Shares" },
  { value: "1.98M", label: "Best reel views" },
  { value: "834k", label: "Best post reach" },
];

export const CONTENT_THEMES = [
  "Mask clearing technique",
  "Immersion diuresis",
  "Advice for new divers",
  "Diver confidence",
  "Beginner mistakes",
  "Air consumption education",
  "Instructor-led advice",
  "Gear-focused content",
  "Tec diving mindset",
  "Real-world underwater behaviour",
];

export const PLATFORMS = [
  {
    name: "Instagram",
    handle: "@traveler_submerged",
    followers: "21,526",
    metrics: [
      { v: "6.24M", l: "Video views" },
      { v: "71.8k", l: "Engagements" },
      { v: "25-44", l: "Core age (61%)" },
    ],
    notes: [
      "Strongest channel for authority and education",
      "Gender split: 60.6% men, 39.4% women",
      "Top countries: US, UK, Brazil, Germany, Italy",
      "Best active window: 18:00 to 21:00",
    ],
  },
  {
    name: "Facebook",
    handle: "Traveler Submerged",
    followers: "8,200",
    metrics: [
      { v: "3.17M", l: "Reach" },
      { v: "1,438", l: "Link clicks" },
      { v: "35-64", l: "Core age range" },
    ],
    notes: [
      "Strong channel for discovery and traffic",
      "Gender split: 62% men, 38% women",
      "Top countries: US, UK, Canada",
      "92% of views from Reels, 90% from suggested content",
    ],
  },
  {
    name: "TikTok",
    handle: "@traveler_submerged",
    followers: "1,541",
    metrics: [
      { v: "+1,439", l: "Net growth, 365 days" },
      { v: "63 / 37", l: "Men / Women %" },
      { v: "Growth", l: "Channel stage" },
    ],
    notes: [
      "Emerging channel for trend-led dive content",
      "Useful for reaching newer, younger dive audiences",
      "Testing ground for short-form formats",
    ],
  },
];

export const AUDIENCE_GROUPS = [
  "Recreational scuba divers",
  "Dive instructors",
  "Dive centre owners and managers",
  "Tec and CCR-curious divers",
  "Freedivers",
  "Underwater photographers and video creators",
  "Dive gear buyers",
  "Dive travel consumers",
  "Marine conservation supporters",
  "Ocean-minded wellness and adventure audiences",
];

export const AUDIENCE_MARKETS = [
  "United States",
  "United Kingdom",
  "Canada",
  "Brazil",
  "Germany",
  "Italy",
  "South Africa",
  "Australia",
  "Malta",
  "Greece",
  "Wider European and Mediterranean markets",
];

export const AUDIENCE_INTERESTS = [
  "Scuba diving",
  "Technical diving",
  "Freediving",
  "Underwater video",
  "Dive equipment",
  "Dive travel",
  "Training progression",
  "Marine conservation",
  "Mindful diving",
  "Digital marketing",
  "AI tools for creators and dive businesses",
];

export const PARTNERSHIPS = [
  {
    title: "Sponsored Social Media Content",
    intro:
      "For dive brands, training agencies, tourism partners and event organisers who want expert-led visibility through short-form content.",
    deliverables: [
      "Instagram Reel",
      "TikTok version",
      "Facebook Reel",
      "Story sequence",
      "Caption and CTA",
      "Post-campaign insights",
    ],
  },
  {
    title: "Product Reviews and Field Testing",
    intro:
      "For dive gear, exposure protection, BCDs, regulators, dive computers, fins, masks, lights, bags, cameras and accessories.",
    deliverables: [
      "Real-world testing",
      "Underwater footage",
      "Short-form video review",
      "Blog feature",
      "Newsletter mention",
      "Story coverage",
      "Audience Q&A",
    ],
  },
  {
    title: "Dive Show and Event Media Coverage",
    intro:
      "For exhibitions, brand activations, speaker sessions, product launches and dive industry events.",
    deliverables: [
      "Pre-event awareness content",
      "Live event stories",
      "Exhibitor highlights",
      "Brand interviews",
      "Reels from the show floor",
      "Post-event recap content",
      "Optional blog or newsletter feature",
    ],
  },
  {
    title: "Brand Consulting for Dive Businesses",
    intro:
      "For dive centres, retailers, resorts, liveaboards and training providers that need clearer digital strategy.",
    deliverables: [
      "Social media audit",
      "Website and funnel review",
      "Email marketing strategy",
      "Content calendar direction",
      "AI workflow setup",
      "Campaign planning",
      "Lead generation support",
    ],
  },
  {
    title: "Content Creation for Dive Brands",
    intro:
      "For businesses that need usable creative assets, not only influencer posting.",
    deliverables: [
      "Reels",
      "Short-form edits",
      "Captions",
      "Blog articles",
      "Email campaigns",
      "Landing page copy",
      "UGC-style content",
      "AI prompt systems for content teams",
    ],
  },
  {
    title: "Speaking, Workshops and Panels",
    intro: "Talks and workshops for the dive industry, creators and dive professionals.",
    deliverables: [
      "How dive centres can use AI without sounding fake",
      "Turning dive content into enquiries",
      "Building trust through educational short-form video",
      "The future of digital marketing for dive professionals",
      "Mindful diving and the psychology of underwater awareness",
      "From instructor to creator, building authority online",
    ],
  },
];

export const PROJECTS = [
  { name: "Procean", note: "Gear collaboration and field content around drysuit and dive equipment use." },
  { name: "The Dive Warehouse Malta", note: "Content and marketing support for Malta's dive retail sector, including Cressi and Beuchat product-focused content." },
  { name: "Dive Systems Malta", note: "Digital marketing, social media support and dive course campaign work for one of Malta's leading dive centres." },
  { name: "Starfish Diving Malta", note: "Social media and campaign support for beginner-focused PADI dive training in St George's Bay." },
  { name: "Ratio Watches", note: "Dive computer and technical timepiece content collaboration." },
  { name: "Healthy Seas & Ghost Diving", note: "Large-scale marine cleanup storytelling, including a feature on the removal of 76 tonnes of marine debris from an abandoned fish farm in Ithaca, Greece." },
  { name: "All For Blue, Greece", note: "Ocean conservation and cleanup-related collaboration." },
  { name: "Zibel, Malta", note: "Marine conservation and local cleanup-related collaboration." },
  { name: "Aelia Wellness, Cyprus", note: "Content creation and blog storytelling for a wellness retreat." },
  { name: "The Gym Bar, Cyprus", note: "Content creation and blog storytelling for a hospitality and restaurant experience in Nicosia Old Town." },
];

export const PROJECT_LOGOS = [
  "Procean",
  "The Dive Warehouse Malta",
  "Cressi Malta",
  "Beuchat Malta",
  "Dive Systems Malta",
  "Starfish Diving Malta",
  "Ratio Watches",
  "Healthy Seas",
  "Ghost Diving",
  "All For Blue",
  "Zibel",
  "Aelia Wellness",
  "The Gym Bar",
];

export const PROJECT_LINKS = [
  { label: "The Gym, Nicosia Old Town", url: "https://www.travelersubmerged.com/the-gym-nicosia-old-town" },
  { label: "Aelia Wellness Retreat", url: "https://www.travelersubmerged.com/aelia-wellness-retreat" },
  { label: "Gigantic Clean-up, Abandoned Fish Farm", url: "https://www.travelersubmerged.com/gigantic-clean-up-abandoned-fish-farm" },
];

export const WHY_VALUES = [
  "Reach a specific diving audience, not a generic travel feed",
  "Explain technical products clearly",
  "Build trust through education",
  "Create content that feels real",
  "Speak to both divers and dive professionals",
  "Connect social visibility with website, email and lead generation",
  "Turn event visibility into follow-up action",
  "Work with a creator who understands diving, gear, training and business",
];

export const RATE_CARD = [
  {
    category: "Sponsored Social Content",
    items: [
      { label: "Single sponsored reel", price: "€350 to €750" },
      { label: "Reel plus story sequence", price: "€500 to €950" },
      { label: "Three-reel campaign", price: "€1,200 to €2,250" },
    ],
  },
  {
    category: "Product Review and Field Testing",
    items: [
      { label: "Social review package", price: "€650 to €1,200" },
      { label: "Full review package with blog", price: "€950 to €1,750" },
      { label: "Long-term gear ambassador package", price: "From €1,500 per month" },
    ],
  },
  {
    category: "Event Media Coverage",
    items: [
      { label: "Half-day event coverage", price: "€750 to €1,200" },
      { label: "Full-day event coverage", price: "€1,200 to €2,000" },
      { label: "Multi-day event media package", price: "€2,500 to €5,000" },
      { label: "Event media partner package", price: "Custom quote" },
    ],
  },
  {
    category: "Brand Consulting",
    items: [
      { label: "Strategy audit", price: "€450 to €750" },
      { label: "90-minute consulting session", price: "€250" },
      { label: "Monthly advisory package", price: "From €750 per month" },
      { label: "Full digital strategy package", price: "From €1,500" },
    ],
  },
  {
    category: "Content Creation",
    items: [
      { label: "Reel editing and caption package", price: "From €150 per reel" },
      { label: "Monthly content bundle", price: "From €750" },
      { label: "Blog article", price: "From €250" },
      { label: "Email sequence", price: "From €450" },
      { label: "Full campaign content kit", price: "From €1,250" },
    ],
  },
  {
    category: "Speaking and Workshops",
    items: [
      { label: "Panel appearance", price: "Custom" },
      { label: "30 to 45 minute talk", price: "From €750" },
      { label: "Half-day workshop", price: "From €1,500" },
      { label: "Full-day workshop", price: "From €2,500" },
    ],
  },
];

export const NEWSLETTER_FOCUS = [
  "Dive education",
  "Gear insight",
  "Content creation for divers",
  "Dive business strategy",
  "Ocean conservation stories",
  "AI tools for dive professionals",
  "Event and brand partner features",
];

export const CONTACT = {
  email: "robin@travelersubmerged.com",
  website: "https://www.travelersubmerged.com",
  instagram: "https://instagram.com/traveler_submerged",
  tiktok: "https://tiktok.com/@traveler_submerged",
  facebook: "https://facebook.com/travelersubmerged",
  location: "Malta, Europe",
  founder: "Robin Bull",
};
